<template>
    <div class="empty" :class="stat!=2?'':'gone'">
        <div class="nodata">
            <img :src="icon" class="imgCls"/>
            <div class="T3">{{ getStat() }}</div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "Empty",
        props: {
            stat: {
                type: Number,
                default: 0
            },
            icon: {
                type: String,
                default: require('@/static/ic_v_emty.png')
            },
            imgWidth: {
                type: String,
                default: '110px'
            }
        },
        methods: {
            getStat() {
                switch (this.stat) {
                    case 0:
                        return "正在加载..."
                    case 1:
                        return "暂无数据"
                }
            }
        },
        computed: {},
    }
</script>

<style scoped>
    .nodata {
        padding-top: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .empty {
        position: absolute;
        left: 0px;
        top: 0px;
        right: 0px;
        bottom: 0px;
        margin: auto;
    }

    .imgCls {
        width: 400px;
        height: 224px;
    }
</style>